import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import ContentHeader from '../../components/ContentHeader';
import { PreDealsList } from './Components/PreDealsList';

const PreDealsPage = () => {
  useDocumentTitle('Pre Deal Search');

  return (
    <>
      <ContentHeader title="Pre-Deal search" />
      <PreDealsList />
    </>
  );
};

export default PreDealsPage;
